import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LanguageSchoolUiModule } from '@digilize/language-school/ui';
import { SharedFeatureComponentsModule } from '@digilize/shared/feature/components/src';
import { SharedFeatureModulesLoginModule } from '@digilize/shared/feature/modules/auth/src';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material/src';
import { SharedUtilsDirectivesModule } from '@digilize/shared/utils/directives/src';
import { SharedUtilsPipesModule } from '@digilize/shared/utils/pipes/src';
import { InlineSVGModule } from '@digilize/shared/ui/inline-svg/src';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { LessonMarkerComponent } from '../lesson-marker/lesson-marker.component';
import { CourseSwitcherComponent } from './course-switcher/course-switcher.component';
import { ExerciseListComponent } from './exercise-list/exercise-list.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PageContainerComponent } from './page-container/page-container.component';
import { TranslocoModule } from '@jsverse/transloco';
import { LangSwitcherComponent } from './navbar/lang-switcher/lang-switcher.component';

const MODULES = [
  CommonModule,
  SharedUtilsDirectivesModule,
  SharedUtilsPipesModule,
  SharedUiComponentsModule,
  SharedFeatureComponentsModule,
  SharedUiMaterialModule,
  InlineSVGModule,
  LazyLoadImageModule,
  FormsModule,
  ReactiveFormsModule,
  TranslocoModule,
  RouterModule,
  SharedFeatureModulesLoginModule,
  LanguageSchoolUiModule,
];

const COMPONENTS = [
  NavbarComponent,
  LessonMarkerComponent,
  PageContainerComponent,
  ExerciseListComponent,
  CourseSwitcherComponent,
  LangSwitcherComponent,
];
@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  exports: [...MODULES, ...COMPONENTS],
})
export class SharedModule {}
